// extracted by mini-css-extract-plugin
export var bigPersons = "Executive-module--bigPersons--43fe9";
export var cardWrapper = "Executive-module--cardWrapper--e6b23";
export var fadeInAnimation = "Executive-module--fadeInAnimation--5b4e1";
export var sliderLayout = "Executive-module--sliderLayout--afa06";